/* ============================================
   RENNIK Search JS
   Shopify Dawn | Desktop + Mobile
   ============================================ */
 
(function () {
  'use strict';
 
  function init() {
    const searchDetails   = document.querySelector('.header__search details');
    const input           = document.querySelector('#Search-In-Modal');
    const emptyPanel      = document.querySelector('.rennik-search-empty-panel');
    const predictive      = document.querySelector('.predictive-search');
    const rennikCloseBtn  = document.querySelector('.rennik-close-search');
 
    if (!input) return;
 
    /* ─────────────────────────────────────────
       CLOSE SEARCH
    ───────────────────────────────────────── */
    function closeSearch() {
      closeEmptyPanel();
      if (searchDetails) {
        searchDetails.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        document.body.style.overflow = '';
      }
    }
 
    /* ─────────────────────────────────────────
       MOBILE CLOSE BUTTON WIRE-UP
       The button lives inside .field, so it is
       always positioned exactly where the
       magnifying-glass was — no JS coordinates.
    ───────────────────────────────────────── */
    if (rennikCloseBtn) {
      rennikCloseBtn.addEventListener('click', closeSearch);
    }
 
    /* ─────────────────────────────────────────
       EMPTY PANEL LOGIC
    ───────────────────────────────────────── */
    function openEmptyPanel() {
      if (!emptyPanel || input.value.trim().length > 0) return;
      emptyPanel.hidden = false;
      if (predictive) predictive.classList.add('rennik-empty-active');
      fixMobilePanel();
    }
 
    function closeEmptyPanel() {
      if (emptyPanel) emptyPanel.hidden = true;
      if (predictive) predictive.classList.remove('rennik-empty-active');
    }
 
    function syncPanel() {
      input.value.trim().length === 0 ? openEmptyPanel() : closeEmptyPanel();
    }
 
    /* ─────────────────────────────────────────
       MOBILE PANEL INLINE-STYLE FIX
       Ensures layout even when CSS specificity
       battles arise on some themes.
    ───────────────────────────────────────── */
    function fixMobilePanel() {
      if (window.innerWidth > 749 || !emptyPanel) return;
 
      Object.assign(emptyPanel.style, {
        position:   'fixed',
        left:       '12px',
        right:      '12px',
        width:      'auto',
        maxWidth:   'none',
        transform:  'none',
        maxHeight:  '55vh',
        overflowY:  'auto',
        overflowX:  'hidden',
        zIndex:     '100001',
      });
 
      // Hide Popular Searches on mobile
      const top = emptyPanel.querySelector('.rennik-search-empty-top');
      if (top) top.style.display = 'none';
 
      // Concern section — styled like popular searches row (label + horizontal pills)
      const filters = emptyPanel.querySelector('.rennik-search-empty-filters');
      if (filters) {
        Object.assign(filters.style, {
          display:                 'flex',
          flexDirection:           'row',
          flexWrap:                'nowrap',
          alignItems:              'center',
          gap:                     '8px',
          paddingBottom:           '12px',
          borderBottom:            '1px solid #e8e5e0',
          overflowX:               'auto',
          overflowY:               'hidden',
          WebkitOverflowScrolling: 'touch',
        });
 
        // h3 — styled as label (like "POPULAR SEARCHES")
        const h3 = filters.querySelector('h3');
        if (h3) {
          Object.assign(h3.style, {
            fontFamily:    'Montserrat, sans-serif',
            fontSize:      '10px',
            fontWeight:    '700',
            color:         '#8a8680',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            whiteSpace:    'nowrap',
            flex:          '0 0 auto',
            margin:        '0 4px 0 0',
          });
        }
      }
 
      // Pills wrapper — display:contents makes <a> tags direct flex items of filters row
      const pills = emptyPanel.querySelector('.rennik-concern-pills');
      if (pills) {
        pills.style.display = 'contents';
        pills.querySelectorAll('a').forEach(a => {
          Object.assign(a.style, {
            display:        'inline-flex',
            alignItems:     'center',
            flex:           '0 0 auto',
            padding:        '7px 13px',
            fontSize:       '12px',
            whiteSpace:     'nowrap',
            height:         'auto',
            borderRadius:   '999px',
            border:         '1px solid #e8e5e0',
            background:     '#fff',
            color:          '#1a1a18',
            textDecoration: 'none',
            width:          'auto',
            minWidth:       'auto',
            maxWidth:       'none',
          });
        });
      }
 
      // Main section — vertical stack
      const main = emptyPanel.querySelector('.rennik-search-empty-main');
      if (main) {
        Object.assign(main.style, {
          display:       'flex',
          flexDirection: 'column',
          gap:           '10px',
          paddingTop:    '12px',
        });
      }
 
      // Hide "Current highlights" label — save space
      const productsH3 = emptyPanel.querySelector('.rennik-search-empty-products h3');
      if (productsH3) productsH3.style.display = 'none';
 
      // Product cards — 46 % wide
      emptyPanel.querySelectorAll('.rennik-empty-product-card').forEach(card => {
        Object.assign(card.style, {
          flex:     '0 0 46%',
          minWidth: '46%',
          maxWidth: '46%',
        });
      });
    }
 
    /* ─────────────────────────────────────────
       EVENT LISTENERS
    ───────────────────────────────────────── */
 
    // Search open / close
    if (searchDetails) {
      searchDetails.addEventListener('toggle', () => {
        if (searchDetails.open) {
          setTimeout(() => {
            input.focus();
            openEmptyPanel();
          }, 100);
        } else {
          closeEmptyPanel();
        }
      });
    }
 
    // Input events
    input.addEventListener('focus', syncPanel);
    input.addEventListener('click', syncPanel);
    input.addEventListener('input', syncPanel);
 
    // Popular-search fill buttons
    document.querySelectorAll('[data-search-fill]').forEach(btn => {
      btn.addEventListener('click', () => {
        input.value = btn.dataset.searchFill;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });
 
    // Close on outside click
    document.addEventListener('click', e => {
      if (
        !e.target.closest('.search-modal') &&
        !e.target.closest('.header__search') &&
        !e.target.closest('.rennik-search-empty-panel')
      ) {
        closeEmptyPanel();
      }
    });
 
    // Escape key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchDetails?.open) closeSearch();
    });
 
    // Re-fix on resize / orientation change
    window.addEventListener('resize', () => {
      if (emptyPanel && !emptyPanel.hidden) fixMobilePanel();
    });
  }
 
  /* ─────────────────────────────────────────
     BOOT
  ───────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(init, 300));
  } else {
    setTimeout(init, 300);
  }
})();